/** @jsxImportSource theme-ui */
import React from 'react';
import { Formik } from 'formik';
import { usePostVossInvoiceMutation } from '@/store/apiService';
import { useNavigate } from 'react-router-dom';
import { PostInvoiceJobQuery } from '@/types/types';
import { toast } from 'react-toastify';
import CreateInvoiceJobForm from './CreateInvoiceJobForm';

type Props = {
    onSubmitSuccess?: () => void;
};

const CreateIncentive: React.FC<Props> = ({ onSubmitSuccess = () => {} }: Props) => {
    const [createVossInvoice, createVossInvoiceState] = usePostVossInvoiceMutation();

    let navigate = useNavigate();

    const initialValues: PostInvoiceJobQuery = {
        companyIds: [],
        InvoiceDate: '',
        ScheduledStartTime: '',
        RecurringSchedule: '',
        OnlyUsage: false,
    };

    return (
        <>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={(values, { resetForm, setErrors, setSubmitting }) => {
                    createVossInvoice(values)
                        .unwrap()
                        .then((res) => {
                            onSubmitSuccess();
                        })
                        .catch((err) => {
                            setSubmitting(false);
                            toast.error(err.data, { autoClose: 5000 });
                        });
                }}
            >
                {(formProps) => {
                    return (
                        <>
                            <CreateInvoiceJobForm
                                {...formProps}
                                additionalErrors={createVossInvoiceState.error}
                            />
                        </>
                    );
                }}
            </Formik>
        </>
    );
};

export default CreateIncentive;
